import React, { useState } from "react";
import { Form, Input } from "antd";
import { resetPassword } from "../../../service/UserService";
import { encryptPassword } from "../../../utility/encryption";
import { validatePasswordforgot } from "../../../utility/validation";
import CustomModal from "../CustomModal/CustomModal";
import CustomButton from "../button/CustomButton";
import InputWrapper from "../Input/Input-Wrapper";
import CustomInput from "../Input/Custom-Input";
import { Check, X } from "lucide-react";
const ResetPasswordModal = ({
  isModalOpen,
  handleCloseModal,
  setToastMessage,
  setToastType,
  setShowToast,
  setLoading,
  logout,
}) => {
  const [form] = Form.useForm();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const passwordCriteria = [
    {
      label: "At least 12 characters long",
      test: (pwd) => pwd.length >= 12,
    },
    {
      label: "Contains uppercase letter",
      test: (pwd) => /[A-Z]/.test(pwd),
    },
    {
      label: "Contains lowercase letter",
      test: (pwd) => /[a-z]/.test(pwd),
    },
    {
      label: "Contains number",
      test: (pwd) => /[0-9]/.test(pwd),
    },
    {
      label: "Contains special character",
      test: (pwd) => /[!@#$%^&*(),.?":{}|<>]/.test(pwd),
    },
  ];

  const allCriteriaMet =
    newPassword &&
    passwordCriteria.every((criteria) => criteria.test(newPassword));
  const passwordsMatch =
    newPassword && confirmPassword && newPassword === confirmPassword;
  const isDifferentFromCurrent =
    newPassword && form.getFieldValue("currentPassword") !== newPassword;

  const isFormValid =
    allCriteriaMet && passwordsMatch && isDifferentFromCurrent;

  const validatePasswordForm = (values) => {
    const errors = [];
    let isValid = true;

    if (!values.currentPassword) {
      errors.push({
        name: "currentPassword",
        errors: ["Current password is required."],
      });
      isValid = false;
    }

    // Validate new password
    if (!values.newPassword) {
      errors.push({
        name: "newPassword",
        errors: ["New password is required."],
      });
      isValid = false;
    } else if (!validatePasswordforgot(values.newPassword)) {
      errors.push({
        name: "newPassword",
        errors: ["Password must meet all requirements."],
      });
      isValid = false;
    }

    // Validate confirm password
    if (!values.confirmPassword) {
      errors.push({
        name: "confirmPassword",
        errors: ["Please confirm your password."],
      });
      isValid = false;
    } else if (values.newPassword !== values.confirmPassword) {
      errors.push({
        name: "confirmPassword",
        errors: ["Passwords do not match."],
      });
      isValid = false;
    }

    // Check if new password is different from current
    if (
      values.currentPassword &&
      values.newPassword &&
      values.currentPassword === values.newPassword
    ) {
      errors.push({
        name: "newPassword",
        errors: ["New password must be different from current password."],
      });
      isValid = false;
    }

    return { isValid, errors };
  };
  const handleResetPassword = async () => {
    try {
      // Get form values
      const values = await form.validateFields();

      // Custom validation
      const { isValid, errors } = validatePasswordForm(values);

      if (!isValid) {
        form.setFields(errors);
        return;
      }

      setLoading(true);

      console.log(values.currentPassword, values.newPassword , "this is the values of the");

      // Encrypt both passwords before sending
      const encryptedCurrentPassword = encryptPassword(values.currentPassword);
      const encryptedNewPassword = encryptPassword(values.newPassword);

      // Prepare payload
      const payload = {
        currentPassword: encryptedCurrentPassword,
        newPassword: encryptedNewPassword,
      };

      // Call API
      const data = await resetPassword(payload);

      // Show success message
   

      setTimeout(() => {
        logout();
      }, 2000);

      // Reset form and close modal
      form.resetFields();
      setNewPassword("");
      setConfirmPassword("");
      handleCloseModal();
    } catch (error) {
      // Show error message
      setToastMessage(error?.message || "Failed to reset password!");
      setToastType("error");
      setShowToast(true);

      setTimeout(() => {
        setToastMessage("");
        setToastType("");
        setShowToast(false);
      }, 2000);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setNewPassword("");
    setConfirmPassword("");
    handleCloseModal();
  };
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);
    form.setFieldsValue({ newPassword: value });
  };
  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);
    form.setFieldsValue({ confirmPassword: value });
  };
  return (
    <CustomModal
      title="Reset Password"
      visible={isModalOpen}
      onCancel={handleCancel}
      //   footer={[
      //     <Button key="cancel" onClick={handleCancel}>
      //       Cancel
      //     </Button>,
      //     <Button key="submit" type="primary" onClick={handleResetPassword}>
      //       Reset Password
      //     </Button>,
      //   ]}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        name="reset_password_form"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        <InputWrapper label={"Current Password"} required>
          <Form.Item
            name="currentPassword"
            rules={[
              { required: true, message: "Current password is required!" },
            ]}
          >
            <CustomInput
              isPassword
              autoComplete="off"
              placeholder="Enter current password"
            />
          </Form.Item>
        </InputWrapper>

        <InputWrapper label={"New Password"} required>
          <Form.Item
            name="newPassword"
            rules={[
              { required: true, message: "New password is required!" },
            ]}
          >
            <CustomInput
              isPassword
              autoComplete="off"
              placeholder="Enter new password"
              onChange={handlePasswordChange}
            />
          </Form.Item>
          {newPassword && (
            <div
              style={{
                marginTop: "8px",
              }}
            >
              {passwordCriteria.map((criteria, index) => {
                const isMet = criteria.test(newPassword);
                return (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom:
                        index < passwordCriteria.length - 1 ? "6px" : "0",
                      color: isMet ? "rgba(6, 103, 16, 1)" : "rgba(200, 0, 0, 1)",
                      fontSize: "12px",
                    }}
                  >
                    {isMet ? (
                      <Check size={16} strokeWidth={2.5} />
                    ) : (
                      <X size={16} strokeWidth={2.5} />
                    )}
                    <span>{criteria.label}</span>
                  </div>
                );
              })}
            </div>
          )}
          {newPassword &&
            form.getFieldValue("currentPassword") === newPassword && (
              <div
                style={{
                  marginTop: "8px",
                  borderRadius: "6px",
                  color: "rgba(200, 0, 0, 1)",
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <X size={16} strokeWidth={2.5} />
                <span>
                  New password must be different from current password.
                </span>
              </div>
            )}
        </InputWrapper>

        <InputWrapper label={"Confirm New Password"} required>
          <Form.Item
            name="confirmPassword"
            rules={[
              { required: true, message: "Please confirm your password!" },
            ]}
          >
            <CustomInput
              isPassword
              autoComplete="off"
              placeholder="Confirm new password"
              onChange={handleConfirmPasswordChange}
            />
          </Form.Item>
          {confirmPassword && (
            <div
              style={{
                marginTop: "8px",
                borderRadius: "6px",
          
                display: "flex",
                alignItems: "center",
                gap: "8px",
                color: passwordsMatch ? "rgba(6, 103, 16, 1)" : "rgba(200, 0, 0, 1)",
                fontSize: "12px",
              }}
            >
              {passwordsMatch ? (
                <>
                  <Check size={16} strokeWidth={2.5} />
                  <span>Password match</span>
                </>
              ) : (
                <>
                  <X size={16} strokeWidth={2.5} />
                  <span>Password do not match</span>
                </>
              )}
            </div>
          )}
        </InputWrapper>
      </Form>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          width: "100%",
          marginTop: "10px",
        }}
      >
        <CustomButton
          style={{
            width: "50%",
          }}
          onClick={handleResetPassword}
          disabled={!isFormValid}
          variant="primary"
        >
          Reset Password
        </CustomButton>
        <CustomButton
          style={{
            width: "50%",
          }}
          onClick={handleCloseModal}
          variant="outlined"
        >
          Cancel
        </CustomButton>
      </div>
    </CustomModal>
  );
};

export default ResetPasswordModal;
